import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, DialogFooter } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
import { NewContact } from 'app/domains/esigning/components/ContactLibrary/NewContact';
import { EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { SubmitButton } from 'shared/domains/forms';
export function Footer(props) {
    const { isEdit, onClose, setTabId, disabled } = props;
    const [newContact, setNewContact] = useState(false);
    const { setValues } = useFormikContext();
    const submitLabel = isEdit
        ? t({ message: 'Save recipient', comment: 'Label for edit eSigning recipient dialog save button' })
        : t({ message: 'Add recipient', comment: 'Label for add eSigning recipient dialog save button' });
    const handleUseNewContact = (values) => {
        var _a, _b, _c, _d, _e, _f, _g;
        setValues({
            email: (_a = values.email) !== null && _a !== void 0 ? _a : '',
            firstName: (_b = values.firstName) !== null && _b !== void 0 ? _b : '',
            lastName: (_c = values.lastName) !== null && _c !== void 0 ? _c : '',
            label: (_d = values.label) !== null && _d !== void 0 ? _d : '',
            mobile: (_e = values.mobile) !== null && _e !== void 0 ? _e : '',
            title: (_f = values.title) !== null && _f !== void 0 ? _f : '',
            type: EsigningRecipientType.Signatory,
            authenticationMode: (_g = values.authenticationMode) !== null && _g !== void 0 ? _g : undefined,
        });
        setNewContact(false);
        setTabId('form');
    };
    return (<Fragment>
      {newContact && <NewContact onClose={() => setNewContact(false)} onSuccess={handleUseNewContact}/>}
      <DialogFooter description={<Button type="button" size="small" appearance="secondary" onClick={() => setNewContact(true)}>
            <Trans comment="Label for creating new contact in add eSigning recipient modal">New contact</Trans>
          </Button>}>
        <Button appearance="secondary" type="button" size="small" onClick={onClose}>
          <Trans comment="Label for closing add eSigning recipient modal">Close</Trans>
        </Button>
        <SubmitButton appearance="primary" disabled={disabled} size="small">
          {submitLabel}
        </SubmitButton>
      </DialogFooter>
    </Fragment>);
}
